
import router from "@/router";
import { defineComponent, reactive } from "vue";
export default defineComponent({
  name: "Home",
  setup() {
    interface Pokemon {
      pokemon: string;
    }
    const state = reactive({
      pokemon: "",
    }) as Pokemon;

    function BuscaRandom() {
      const min = Math.ceil(1);
      const max = Math.floor(807);
      const random: number = Math.floor(Math.random() * (max - min)) + min;
      const random2: string = random.toString();
      state.pokemon = random2;
      router.push({ name: "Pokemon", params: { id: state.pokemon } });
    }
    function BuscaPokemon() {
      router.push({ name: "Pokemon", params: { id: state.pokemon } });
    }

    return {
      state,
      BuscaRandom,
      BuscaPokemon,
    };
  },
});
